@if (efastIsShown) {
  <div class="margin-y-1">
    <!-- count {{this.efastHits.found}} countlist {{countList.length}} -->
    @for (count of countList; track count) {
      <button  class="usa-button margin-top-1 {{isactive(count)}}" type="submit" (click)='pageSelected(count)'>{{count/recordsMax + 1}}</button>
    }
  </div>
}
